// extracted by mini-css-extract-plugin
export default {"soldOutLabel":"tUTjcm","container":"SMV5RM"};